type Coordinate = string | number;

export const getMapsURL = (lat: Coordinate, lng: Coordinate) => `https://maps.google.com/?q=${lat},${lng}`;
